// extracted by mini-css-extract-plugin
module.exports = {"AppLayout":"AppLayout_AppLayout__fZ_RE"};